import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {PolygonService} from "../../services/polygons-service.service";
import {ServiceAreaDialogService} from "../../services/service-area-dialog-service.service";
import {ServiceAreasService} from "../../services/service-areas-service.service";

export class bringozServiceAreasViewCtrl implements IController {

  serviceAreaList: any[];
  selectedAreaIds: any;
  permission: any;
  branchId?: string;
  branchIds?: any[];
  onChange: Function;

  private serviceAreasRef: any;
  private featureCollection: any;
  private selectedFeature: any;

  /* @ngInject */
  constructor(private $log, private $serviceArea, private serviceAreaDialogService: ServiceAreaDialogService,
              private polygonService: PolygonService, private serviceAreasService: ServiceAreasService) {
  }

  $onInit() {
    this.serviceAreasRef = this.$serviceArea();
    this.featureCollection = undefined;
    this.selectedFeature = undefined;

    if (!this.selectedAreaIds) {
      this.selectedAreaIds = [];
    }

    if (!this.serviceAreaList) {
      this._getServiceAreas();
    } else {
      const serviceAreas = this._getServiceAreasByIds(this.selectedAreaIds, this.serviceAreaList);
      this.featureCollection = this.polygonService.getFeatureCollection(serviceAreas);
    }
  };

  $onChanges(changes) {
    if (
      (changes.selectedAreaIds && !changes.selectedAreaIds.isFirstChange()) ||
      (changes.serviceAreaList && !changes.serviceAreaList.isFirstChange())
    ) {
      if (!this.selectedAreaIds) {
        this.selectedAreaIds = [];
      }
      const serviceAreas = this._getServiceAreasByIds(this.selectedAreaIds, this.serviceAreaList);
      this.featureCollection = this.polygonService.getFeatureCollection(serviceAreas);
    }
  };

  ////////////////////////////////////////////////////////////////////

  onAddServiceAreas(event) {
    this.serviceAreaDialogService.addServiceArea(event, this.branchId, this.serviceAreaList, this.selectedAreaIds)
      .then((updatedAreas) => {
        if (updatedAreas) {
          this.onChange({updatedAreas: updatedAreas});
        }
      })
      .catch((error) => {
        this.$log.info(error)
      })
  }

  onSelectFeature(feature) {
    this.selectedFeature = feature;
  }

  // ******************************
  //        Private methods
  // ******************************

  private _getServiceAreas() {
    this.serviceAreasService.getAll({branchIds: this.branchIds})
      // .then((areaIds) => {
      //   return this.serviceAreasRef.$asyncValues(areaIds);
      // })
      .then((serviceAreasResponse: any[]) => {
        this.serviceAreaList = serviceAreasResponse;

        const serviceAreas = this._getServiceAreasByIds(this.selectedAreaIds, this.serviceAreaList);
        this.featureCollection = this.polygonService.getFeatureCollection(serviceAreas);
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Failed to get service areas ' +
            'DeliveriesViewCtrl \n' + error);
        }
      })
  }

  _getServiceAreasByIds(selectedAreaIds, serviceAreaList) {
    return _.filter(serviceAreaList, (area) => {
      return _.indexOf(selectedAreaIds, area.areaId) !== -1
    })
  }

}

angular
  .module('bringoz.admin.service-areas')
  .component('bringozServiceAreasView', {
    bindings: {
      serviceAreaList: '<?',
      selectedAreaIds: '<?',
      permission: '<',
      branchId: '<?',
      branchIds: '<?',
      onChange: '&'
    },
    template: require('./bringoz-service-areas-view.html').default,
    controller: bringozServiceAreasViewCtrl
  });
